<template>
  <div>
    <div class="uk-navbar-container">
      <div class="uk-container uk-container-expand">
        <nav class="uk-navbar" uk-navbar>
          <div class="uk-navbar-left">
            <router-link class="uk-navbar-item uk-logo" to="/">
              <img src="https://faithit-eszuskq0bptlfh8awbb.stackpathdns.com/wp-content/themes/faithit-v3/assets/images/Faithit_Blue.svg" alt="Faithit">
            </router-link>
          </div>
          <div class="uk-navbar-right">
            <a class="uk-navbar-toggle" uk-navbar-toggle-icon href="#" uk-toggle="target: #offcanvas-flip"></a>
          </div>
        </nav>
      </div>
    </div>
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <footer class="uk-section uk-section-muted">
      <div class="uk-container">
        <p>
          Made with ❤️  by Faithit
        </p>
      </div>
    </footer>
    <div class="uk-offcanvas-content">
      <div id="offcanvas-flip" uk-offcanvas="flip: true; overlay: true">
        <div class="uk-offcanvas-bar uk-flex uk-flex-column">
            <ul class="uk-nav uk-nav-primary uk-nav-center uk-margin-auto-vertical">
                <li class="uk-active"><a href="#">Active</a></li>
                <li class="uk-parent">
                    <a href="#">Parent</a>
                    <ul class="uk-nav-sub">
                        <li><a href="#">Sub item</a></li>
                        <li><a href="#">Sub item</a></li>
                    </ul>
                </li>
                <li class="uk-nav-header">Header</li>
                <li><a href="#"><span class="uk-margin-small-right" uk-icon="icon: table"></span> Item</a></li>
                <li><a href="#"><span class="uk-margin-small-right" uk-icon="icon: thumbnails"></span> Item</a></li>
                <li class="uk-nav-divider"></li>
                <li><a href="#"><span class="uk-margin-small-right" uk-icon="icon: trash"></span> Item</a></li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
UIkit.use(Icons)

export default {
  name: 'app'
}
</script>

<style lang="less">
@import './assets/theme/theme.less';

.uk-logo img {
  height: 50px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue